import { createFileRoute } from '@tanstack/react-router'
import TarefasListPage from '@/pages/tarefas/tarefas-list-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/atividades
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/atividades',
)({
  component: function AtividadesRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.OPORTUNIDADES} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.CRM_ALL, CAPABILITIES.CRM_OWN]}
          dashboardId={dashboardId}
        >
          <TarefasListPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
